var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "file-view-box"
    },
    [
      _vm.file.url
        ? _c(
            "div",
            {
              staticClass: "box-bg full-view",
              attrs: { id: _vm.fileBoxId },
              on: { dblclick: _vm.fullScreen }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.loading && _vm.file.url,
                      expression: "!loading && file.url"
                    }
                  ],
                  staticClass: "btns",
                  class: ["file-type" + _vm.file.fileType]
                },
                [
                  _vm.isDownload && _vm.file.fileType == 1
                    ? _c(
                        "span",
                        {
                          staticClass: "icon-btn iconfont",
                          on: { click: _vm.download }
                        },
                        [_vm._v("")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.loading,
                          expression: "!loading"
                        }
                      ],
                      staticClass: "icon-btn iconfont full-btn",
                      on: { click: _vm.fullScreen }
                    },
                    [_vm._v("")]
                  )
                ]
              ),
              _vm._v(" "),
              _c("iframe", {
                key: _vm.file.url,
                staticClass: "file-view",
                attrs: { src: _vm.file.url, frameborder: "0", id: "iframe" }
              })
            ]
          )
        : _c("div", { staticClass: "no-data" }, [_vm._v("没有相关文件")])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23829df1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23829df1","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FileView.vue
// module id = 568
// module chunks = 14